import { useMemo } from "react";
import { useState } from "react";
import { getDateUnrealied } from "../functions";

function SortTable2(arrData, key, isSortedAtoZ) {
  const [sortingCondition, setSortingCondition] = useState({
    sortKey: key,
    sortOrder: isSortedAtoZ,
  });

  const sortedArr = useMemo(() => {
    const filterType = sortingCondition.sortKey;
    const sortingInAscending = sortingCondition.sortOrder;
    if (filterType === "investmentDate" && !sortingInAscending) {
      return [...arrData]?.sort((a, b) => {
        let aa = getDateUnrealied(a?.investmentDate);
        let bb = getDateUnrealied(b?.investmentDate);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
      });
    } else if (filterType === "investmentDate" && sortingInAscending) {
      return [...arrData]
        ?.sort((a, b) => {
          let aa = getDateUnrealied(a?.investmentDate);
          let bb = getDateUnrealied(b?.investmentDate);
          return aa < bb ? -1 : aa > bb ? 1 : 0;
        })
        .reverse();
    } else if (sortingInAscending) {
      return [...arrData]?.sort(
        (a, b) =>
          Number(a?.[filterType]).toFixed(2) -
          Number(b?.[filterType]).toFixed(2)
      );
    } else {
      return Array.isArray(arrData)
        ? [...arrData]
            ?.sort(
              (a, b) =>
                Number(a?.[filterType]).toFixed(2) -
                Number(b?.[filterType]).toFixed(2)
            )
            .reverse()
        : [];
    }
  }, [sortingCondition, arrData]);

  return {
    isAscending: sortingCondition.sortOrder,
    keyToSort: sortingCondition.sortKey,
    arrData: sortedArr,
    setKeyForOrdering: (key, condition) => {
      setSortingCondition((prev) => {
        return {
          sortKey: key,
          sortOrder: condition,
        };
      });
    },
  };
}

export default SortTable2;
